import { ElementRef, Renderer2, Directive, AfterViewInit, OnDestroy } from '@angular/core';

@Directive({
  selector: '[cgPasswordToggle]',
})
export class PasswordToggleDirective implements AfterViewInit, OnDestroy {
  private shown = false;
  private toggleIcon: HTMLElement | HTMLImageElement;
  private unlisten: () => void;

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngAfterViewInit() {
    const input = this.el.nativeElement;
    if (input.type != 'password') {
      console.warn('PasswordToggleDirective should only be applied to an <input type="password"> element.');
      return;
    }
    this.toggleIcon = this.renderer.createElement('i');
    this.renderer.addClass(this.toggleIcon, 'password-toggle');
    this.renderer.addClass(this.toggleIcon, 'bi');
    this.renderer.addClass(this.toggleIcon, 'bi-eye-fill');
    this.renderer.setAttribute(this.toggleIcon, 'role', 'button');
    this.renderer.setAttribute(this.toggleIcon, 'aria-label', 'Show or hide password');


    const parent = this.renderer.parentNode(input);
    if (!parent || parent.className.includes('col') || parent.className.includes('form-group')) {
      // Create a wrapper div with position: relative
      const wrapper = this.renderer.createElement('div');
      this.renderer.setStyle(wrapper, 'position', 'relative');
      this.renderer.setStyle(wrapper, 'display', 'block');

      this.renderer.insertBefore(parent, wrapper, input);
      this.renderer.appendChild(wrapper, input);
      this.renderer.appendChild(wrapper, this.toggleIcon);
    }
    else if (!parent.className && (!parent.style || parent.style.position === '')) {
      this.renderer.setStyle(parent, 'position', 'relative');
      this.renderer.appendChild(parent, this.toggleIcon);
    }
    else {
      this.renderer.appendChild(parent, this.toggleIcon);
    }
    this.unlisten = this.renderer.listen(this.toggleIcon, 'click', () => this.toggle());
  }

  toggle(): void {
    this.shown = !this.shown;
    this.el.nativeElement.type = this.shown ? 'text' : 'password';
    this.renderer.removeClass(this.toggleIcon, this.shown ? 'bi-eye-fill' : 'bi-eye-slash-fill');
    this.renderer.addClass(this.toggleIcon, this.shown ? 'bi-eye-slash-fill' : 'bi-eye-fill');
    this.renderer.setAttribute(this.toggleIcon, 'aria-label', this.shown ? 'Hide password' : 'Show password');

    if (this.shown) {
      this.renderer.addClass(this.toggleIcon, 'flipped');
    } else {
      this.renderer.removeClass(this.toggleIcon, 'flipped');
    }

  }

  ngOnDestroy(): void {
    if (this.unlisten) {
      this.unlisten();
    }
  }
}